<nz-layout>
  <nz-sider
    nzTheme="light"
    nzCollapsible
    [nzCollapsedWidth]="isMobile ? 0 : size"
    [nzWidth]="250"
    [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null"
    >
    <div style="height: 100%; display: flex; flex-direction: column;">
      <a class="logo" routerLink="/">
        @if (!isCollapsed) {
          <img
            class="logo-icon"
            src="/assets/images/logo.svg"
            />
        }
        @if (isCollapsed) {
          <img
            class="logo-icon"
            src="/assets/images/logo-mini.svg"
            />
        }
      </a>
      <div style="flex: 1; overflow: auto; padding: 0 8px;">
        <ul nz-menu nzTheme="light" nzMode="inline" class="sider-menu" style="border: 0">
          <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: navigation }"></ng-container>
          <ng-template #menuTpl let-menus>
            @for (menu of menus; track menu.id) {

              @if (!menu.children && menu.show) {
                <ng-container *ngxPermissionsOnly="menu.role || []">
                  <ng-container *ngxPermissionsExcept="menu.excludeRole || []">
                    <li
                      class="menu-item"
                      nz-menu-item
                      [nzPaddingLeft]="menu.level * 24"
                      [nzDisabled]="menu.disabled"
                      [nzSelected]="menu.selected"
                      [routerLink]="menu.url"
                      nzMatchRouter
                      nz-tooltip
                      nzTooltipPlacement="right"
                      [nzTooltipTitle]="isCollapsed && menu.type === 'item' ? (menu.translate | translate) : ''"
                      nzSelected
                      >
                      @if (menu.icon) {
                        @if (menu.id === 'bookinghub') {
                          <span class="anticon anticon-shopping ng-star-inserted">
                            <svg width="18" height="18" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M8.06028 0.577777V23.4222C8.06028 24.0192 7.32489 24.2203 7.06102 23.6969L6.70415 22.9853L4.37039 18.3437C4.32929 18.2637 4.21466 18.2637 4.17573 18.3437L1.84413 22.9853L1.48509 23.6991C1.22122 24.2225 0.48584 24.0213 0.48584 23.4244V0.577777C0.48584 0.259833 0.723756 0.00244141 1.01791 0.00244141H7.52821C7.82236 0.00244141 8.06028 0.259833 8.06028 0.577777Z"
                                fill="#DD2A37" />
                              <path
                                d="M22 4.53943V6.62228C22 9.12907 19.9691 11.16 17.4623 11.16H10.6924C10.169 11.16 9.74292 10.7361 9.74292 10.2105V0.949023C9.74292 0.425604 10.1668 -0.000488281 10.6924 -0.000488281H17.4623C19.9691 -0.000488281 22 2.03047 22 4.53726V4.53943Z"
                                fill="#DD2A37" />
                              <path
                                d="M22 17.3788V19.4595C22 21.9663 19.9691 23.9994 17.4623 23.9994H10.6924C10.169 23.9994 9.74292 23.5754 9.74292 23.0499V13.7884C9.74292 13.2649 10.1668 12.8389 10.6924 12.8389H17.4623C19.9691 12.8389 22 14.8698 22 17.3766V17.3788Z"
                                fill="#DD2A37" />
                            </svg>
                          </span>
                        } @else {
                          <span nz-icon [nzType]="menu.icon"></span>
                        }

                      } @else {
                        <span style="color: #989898; font-size: 12px" nz-icon nzType="right" nzTheme="outline"></span>
                      }
                      <span>{{ menu.translate | translate }}</span>
                    </li>
                  </ng-container>
                </ng-container>
              } @else {
                @if (menu.show) {
                  <ng-container *ngxPermissionsOnly="menu.role || []">
                    <ng-container *ngxPermissionsExcept="menu.excludeRole || []">
                      <li
                        nz-submenu
                        [nzPaddingLeft]="menu.level * 24"
                        [nzOpen]="menu.open"
                        [nzTitle]="menu.translate | translate"
                        [nzIcon]="menu.icon"
                        [nzDisabled]="menu.disabled"
                        [routerLink]="menu.url"
                        nzMatchRouter
                        >
                        <ul style="font-size: 12px;">
                          <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu.children }" />
                        </ul>
                      </li>
                    </ng-container>
                  </ng-container>
                }
              }
            }
          </ng-template>
          <!--      <ng-container *ngFor="let nav of navigation">-->
          <!--        <ng-container-->
          <!--          *ngIf="nav.children && nav.children.length; else singleNav"-->
          <!--        >-->
          <!--          <li-->
          <!--            nzMenuClassName="main-item"-->
          <!--            nz-submenu-->
          <!--            *ngxPermissionsOnly="nav.role || []"-->
          <!--          >-->
          <!--            <span title-->
          <!--              ><i *ngIf="nav.icon" nz-icon [nzType]="nav.icon"></i-->
          <!--              ><span class="main-item">{{-->
          <!--                nav.translate | translate-->
        <!--              }}</span></span-->
        <!--            >-->
        <!--            <ul>-->
        <!--              <ng-container *ngFor="let navChild of nav.children">-->
        <!--                <li-->
        <!--                  *ngxPermissionsOnly="navChild.role || []"-->
        <!--                  [id]="navChild.id"-->
        <!--                  nz-menu-item-->
        <!--                  style="font-size: 12px"-->
        <!--                  [routerLink]="navChild.url"-->
        <!--                  routerLinkActive="ant-menu-item-selected"-->
        <!--                  [routerLinkActiveOptions]="{ exact: true }"-->
        <!--                >-->
        <!--                  {{ navChild.translate | translate }}-->
      <!--                </li>-->
    <!--              </ng-container>-->
  <!--            </ul>-->
<!--          </li>-->
<!--        </ng-container>-->
<!--        <ng-template #singleNav>-->
<!--          <li-->
<!--            nz-menu-item-->
<!--            [id]="nav.id"-->
<!--            [routerLink]="nav.url"-->
<!--            *ngxPermissionsOnly="nav.role || []"-->
<!--            routerLinkActive="ant-menu-item-selected"-->
<!--          >-->
<!--            <i *ngIf="nav.icon" nz-icon [nzType]="nav.icon"></i>-->
<!--            <span>{{ nav.translate | translate }}</span>-->
<!--          </li>-->
<!--        </ng-template>-->
<!--      </ng-container>-->
</ul>
</div>

<div style="display: flex;align-items: center;justify-content: center; margin-bottom: 10px; margin-top: 10px;">
  <a
    href="https://bookinghub.ge/blogs/bookinghubge-pirveli-kartuli-onlain-javshnebis-platforma"
    target="_blank">
    <svg width="40" height="40" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.06028 0.577777V23.4222C8.06028 24.0192 7.32489 24.2203 7.06102 23.6969L6.70415 22.9853L4.37039 18.3437C4.32929 18.2637 4.21466 18.2637 4.17573 18.3437L1.84413 22.9853L1.48509 23.6991C1.22122 24.2225 0.48584 24.0213 0.48584 23.4244V0.577777C0.48584 0.259833 0.723756 0.00244141 1.01791 0.00244141H7.52821C7.82236 0.00244141 8.06028 0.259833 8.06028 0.577777Z"
        fill="#DD2A37" />
      <path
        d="M22 4.53943V6.62228C22 9.12907 19.9691 11.16 17.4623 11.16H10.6924C10.169 11.16 9.74292 10.7361 9.74292 10.2105V0.949023C9.74292 0.425604 10.1668 -0.000488281 10.6924 -0.000488281H17.4623C19.9691 -0.000488281 22 2.03047 22 4.53726V4.53943Z"
        fill="#DD2A37" />
      <path
        d="M22 17.3788V19.4595C22 21.9663 19.9691 23.9994 17.4623 23.9994H10.6924C10.169 23.9994 9.74292 23.5754 9.74292 23.0499V13.7884C9.74292 13.2649 10.1668 12.8389 10.6924 12.8389H17.4623C19.9691 12.8389 22 14.8698 22 17.3766V17.3788Z"
        fill="#DD2A37" />
    </svg>
  </a>
</div>
</div>
</nz-sider>
<nz-layout>
  <nz-header>
    <div nz-flex nzGap="small" nzJustify="space-between" nzAlign="center">
      @if (size === 0 && isCollapsed) {
        <div nz-col nzFlex="initial">
          <a class="logo" routerLink="/cashier">
            <img class="logo-icon" src="/assets/images/logo-mini.svg" />
          </a>
        </div>
      }
      <div nz-col nzFlex="initial">
        <i
          class="trigger"
          nz-icon
          [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
          (click)="isCollapsed = !isCollapsed"
        ></i>
      </div>

      @if (isMobile) {
        <div nz-col nzFlex="auto"></div>
      }

      @if (!isMobile) {
        <div nz-col nzFlex="auto" style="height: 64px">
          <beautyapp-appointment-search
            *ngxPermissionsOnly="['Admin', 'Administrator', 'Manager']"
          ></beautyapp-appointment-search>
        </div>
      }

      <div
        nz-col
        nzFlex="initial"
        *ngxPermissionsOnly="['Admin', 'Administrator', 'Manager']"
        style="display: flex;align-items: center;"
        >
        <nz-space>
          <!--            @if (isMobile) {-->
          <!--              <div *nzSpaceItem style="display: flex;align-items: center;justify-content: center;">-->
          <!--                <a-->
          <!--                  href="https://bookinghub.ge/blogs/bookinghubge-pirveli-kartuli-onlain-javshnebis-platforma"-->
          <!--                  target="_blank">-->
          <!--                  <svg width="18" height="18" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
          <!--                    <path-->
          <!--                      d="M8.06028 0.577777V23.4222C8.06028 24.0192 7.32489 24.2203 7.06102 23.6969L6.70415 22.9853L4.37039 18.3437C4.32929 18.2637 4.21466 18.2637 4.17573 18.3437L1.84413 22.9853L1.48509 23.6991C1.22122 24.2225 0.48584 24.0213 0.48584 23.4244V0.577777C0.48584 0.259833 0.723756 0.00244141 1.01791 0.00244141H7.52821C7.82236 0.00244141 8.06028 0.259833 8.06028 0.577777Z"-->
          <!--                      fill="#DD2A37" />-->
          <!--                    <path-->
          <!--                      d="M22 4.53943V6.62228C22 9.12907 19.9691 11.16 17.4623 11.16H10.6924C10.169 11.16 9.74292 10.7361 9.74292 10.2105V0.949023C9.74292 0.425604 10.1668 -0.000488281 10.6924 -0.000488281H17.4623C19.9691 -0.000488281 22 2.03047 22 4.53726V4.53943Z"-->
          <!--                      fill="#DD2A37" />-->
          <!--                    <path-->
          <!--                      d="M22 17.3788V19.4595C22 21.9663 19.9691 23.9994 17.4623 23.9994H10.6924C10.169 23.9994 9.74292 23.5754 9.74292 23.0499V13.7884C9.74292 13.2649 10.1668 12.8389 10.6924 12.8389H17.4623C19.9691 12.8389 22 14.8698 22 17.3766V17.3788Z"-->
          <!--                      fill="#DD2A37" />-->
        <!--                  </svg>-->
      <!--                </a>-->
    <!--              </div>-->
    <!--            } @else {-->
    <!--              <div *nzSpaceItem>-->
    <!--                <a class="bookinghub"-->
    <!--                   href="https://bookinghub.ge/blogs/bookinghubge-pirveli-kartuli-onlain-javshnebis-platforma"-->
    <!--                   target="_blank">-->
    <!--                  <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
    <!--                    <path-->
    <!--                      d="M8.06028 0.577777V23.4222C8.06028 24.0192 7.32489 24.2203 7.06102 23.6969L6.70415 22.9853L4.37039 18.3437C4.32929 18.2637 4.21466 18.2637 4.17573 18.3437L1.84413 22.9853L1.48509 23.6991C1.22122 24.2225 0.48584 24.0213 0.48584 23.4244V0.577777C0.48584 0.259833 0.723756 0.00244141 1.01791 0.00244141H7.52821C7.82236 0.00244141 8.06028 0.259833 8.06028 0.577777Z"-->
    <!--                      fill="#DD2A37" />-->
    <!--                    <path-->
    <!--                      d="M22 4.53943V6.62228C22 9.12907 19.9691 11.16 17.4623 11.16H10.6924C10.169 11.16 9.74292 10.7361 9.74292 10.2105V0.949023C9.74292 0.425604 10.1668 -0.000488281 10.6924 -0.000488281H17.4623C19.9691 -0.000488281 22 2.03047 22 4.53726V4.53943Z"-->
    <!--                      fill="#DD2A37" />-->
    <!--                    <path-->
    <!--                      d="M22 17.3788V19.4595C22 21.9663 19.9691 23.9994 17.4623 23.9994H10.6924C10.169 23.9994 9.74292 23.5754 9.74292 23.0499V13.7884C9.74292 13.2649 10.1668 12.8389 10.6924 12.8389H17.4623C19.9691 12.8389 22 14.8698 22 17.3766V17.3788Z"-->
    <!--                      fill="#DD2A37" />-->
  <!--                  </svg>-->
  <!--                  <div class="bookinghub_text">მიიღე ონლაინ ჯავშნები</div>-->
<!--                </a>-->
<!--              </div>-->
<!--            }-->
<!-- @if (isMobile) {
  <span *nzSpaceItem class="current-cashier-pending" nz-icon nzType="info-circle" nzTheme="twotone"
  (click)="openImportantInfo()"></span>
} @else {
  <nz-alert
    *nzSpaceItem
    class="current-cashier-pending"
    style="cursor: pointer"
    nzShowIcon
    nzType="info"
    [nzMessage]="'ALERT.important_update' | translate"
    (click)="openImportantInfo()"
  ></nz-alert>
} -->

@if (cashiersCurrentPending$ | async) {
  @if (isMobile) {
    <span *nzSpaceItem class="current-cashier-pending" nz-icon nzType="reconciliation" nzTheme="twotone"
    nzTwotoneColor="#FF3FB4" [routerLink]="['/cashier']"></span>
  } @else {
    <nz-alert *nzSpaceItem
      class="current-cashier-pending"
      [routerLink]="['/cashier']"
      style="cursor: pointer"
      nzShowIcon
      nzIconType="reconciliation"
      nzType="error"
      [nzMessage]="'CASHIER.need_open' | translate"
    ></nz-alert>
  }
}
</nz-space>
</div>
@if (importState$ | async; as importState) {
  @if (importState.isActive) {
    <div *nzSpaceItem style="display: flex; align-items: center; gap: 8px; cursor: pointer;"
         routerLink="/customers/upload">
      <nz-progress
        [nzPercent]="importState.overallProgress"
        nzType="circle"
        [nzWidth]="28"
        nzStrokeLinecap="square"
        [nzShowInfo]="false"
      ></nz-progress>
      @if (!isMobile) {
        <span style="font-size: 12px; white-space: nowrap;">
          {{ importState.phaseLabel }}
        </span>
      }
    </div>
  }
}
@if (!isMobile) {
  <div nz-col nzFlex="initial">
    <nz-badge [nzCount]="(notificationCount$ | async) || 0" nzSize="small" (click)="openNotification()">
      <button nz-button nzType="default" nzShape="circle">
        <span class="head-example" nz-icon nzType="bell"></span>
      </button>
    </nz-badge>
  </div>
}
<div nz-col nzFlex="initial">
  <nz-select
    [(ngModel)]="lang"
    (ngModelChange)="langChange($event)"
    nzBorderless
    >
    <nz-option nzValue="ka" nzLabel="ქართ."></nz-option>
    <nz-option nzValue="en" nzLabel="Eng."></nz-option>
    <nz-option nzValue="ru" nzLabel="Рус."></nz-option>
  </nz-select>
</div>
<div nz-col nzFlex="initial">
  <nz-space-compact>
    @if (selectedBranch$ | async; as branchSelected) {
      <button
        *ngxPermissionsOnly="['Admin', 'Manager', 'Administrator']"
        nz-button
        nz-dropdown
        nzTrigger="click"
        [nzDropdownMenu]="branchMenu"
        nzPlacement="bottomRight"
        >
        {{ branchSelected?.name }}
      </button>
    }
    <button
      nz-button
      nz-dropdown
      [nzDropdownMenu]="profile"
      nzPlacement="bottomRight"
      >
      <i nz-icon nzType="user"></i>
      @if (!isMobile) {
        {{ authUser?.username }}
      }
    </button>
  </nz-space-compact>
  <nz-dropdown-menu #profile="nzDropdownMenu">
    <ul nz-menu style="min-width: 150px">
      <li nz-menu-item routerLink="/admin" *ngxPermissionsOnly="['Admin', 'Manager']">
        {{ 'header.account.dropdown.admin' | translate }}
      </li>
      <li nz-menu-item routerLink="/profile">
        {{ 'header.account.dropdown.profile' | translate }}
      </li>
      <li nz-menu-divider></li>
      <li nz-menu-item (click)="logout()">
        <nz-space>
          <i *nzSpaceItem nz-icon nzType="logout" nzTheme="outline"></i>
          <span *nzSpaceItem>{{
            'header.account.dropdown.logOut' | translate
          }}</span>
        </nz-space>
      </li>
    </ul>
  </nz-dropdown-menu>

  <nz-dropdown-menu #branchMenu="nzDropdownMenu">
    <ul nz-menu>
      @if (branches$ | async; as branches) {
        @for (branch of branches; track branch.id) {
          <li
            nz-menu-item
            (click)="setBranch(branch)"
            >
            {{ branch.name }}
          </li>
        }
      }
    </ul>
  </nz-dropdown-menu>
</div>
</div>
</nz-header>
<nz-content>
  <router-outlet></router-outlet>
</nz-content>
<nz-footer nzTheme="light">
  {{ 'footer.title' | translate }} WebApp.Ge - {{ version }}
</nz-footer>
</nz-layout>
</nz-layout>


<ng-template #notificationBtnTpl let-notification>
  <button nz-button nzType="primary" nzSize="small" (click)="notification.close(true)">Open</button>
</ng-template>
